/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Misc_Fairuse_Section6body2Inputs */

const id_misc_fairuse_section6body2 = /** @type {(inputs: Misc_Fairuse_Section6body2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jika Anda memiliki pertanyaan tentang Kebijakan Penggunaan Wajar ini atau jika Anda percaya bahwa konten atau data apa pun di Situs kami melanggar hak cipta Anda, silakan hubungi kami di:`)
};

const ms_misc_fairuse_section6body2 = /** @type {(inputs: Misc_Fairuse_Section6body2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jika anda mempunyai sebarang soalan tentang Dasar Penggunaan Adil ini atau jika anda percaya mana-mana kandungan atau data di Laman kami melanggar hak cipta anda, sila hubungi kami di:`)
};

const da_misc_fairuse_section6body2 = /** @type {(inputs: Misc_Fairuse_Section6body2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hvis du har spørgsmål til denne Fair Use Politik eller mener at noget indhold eller data på vores Side krænker din ophavsret, bedes du kontakte os på:`)
};

const de_misc_fairuse_section6body2 = /** @type {(inputs: Misc_Fairuse_Section6body2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wenn Sie Fragen zu dieser Fair-Use-Richtlinie haben oder glauben, dass Inhalte oder Daten auf unserer Site Ihr Urheberrecht verletzen, kontaktieren Sie uns bitte unter:`)
};

const en_us2_misc_fairuse_section6body2 = /** @type {(inputs: Misc_Fairuse_Section6body2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`If you have any questions about this Fair Use Policy or if you believe that any content or data on our Site infringes on your copyright, please contact us at:`)
};

const es_es2_misc_fairuse_section6body2 = /** @type {(inputs: Misc_Fairuse_Section6body2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Si tienes alguna pregunta sobre esta Política de Uso Justo o si crees que algún contenido o dato en nuestro Sitio infringe tu derecho de autor, contáctanos en:`)
};

const es_mx2_misc_fairuse_section6body2 = /** @type {(inputs: Misc_Fairuse_Section6body2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Si tienes alguna pregunta sobre esta Política de Uso Justo o si crees que algún contenido o dato en nuestro Sitio infringe tu derecho de autor, contáctanos en:`)
};

const fil_misc_fairuse_section6body2 = /** @type {(inputs: Misc_Fairuse_Section6body2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kung mayroon kang anumang mga katanungan tungkol sa Patakaran sa Patas na Paggamit na ito o kung naniniwala ka na ang anumang nilalaman o data sa aming Site ay lumalabag sa iyong copyright, mangyaring makipag-ugnayan sa amin sa:`)
};

const fr_misc_fairuse_section6body2 = /** @type {(inputs: Misc_Fairuse_Section6body2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Si vous avez des questions sur cette politique d'utilisation équitable ou si vous estimez qu'un contenu ou des données sur notre Site enfreignent vos droits d'auteur, veuillez nous contacter à :`)
};

const it_misc_fairuse_section6body2 = /** @type {(inputs: Misc_Fairuse_Section6body2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Se hai domande su questa Politica di Fair Use o se ritieni che qualsiasi contenuto o dato sul nostro Sito violi il tuo copyright, contattaci all'indirizzo:`)
};

const hu_misc_fairuse_section6body2 = /** @type {(inputs: Misc_Fairuse_Section6body2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ha bármilyen kérdése van ezzel a Fair Use irányelvvel kapcsolatban, vagy úgy véli, hogy a Webhelyünkön található bármely tartalom vagy adat sérti a szerzői jogát, kérjük, lépjen kapcsolatba velünk a következő címen:`)
};

const nl_misc_fairuse_section6body2 = /** @type {(inputs: Misc_Fairuse_Section6body2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Als u vragen heeft over dit Fair Use-beleid of als u van mening bent dat inhoud of gegevens op onze Site uw auteursrecht schenden, neem dan contact met ons op via:`)
};

const no_misc_fairuse_section6body2 = /** @type {(inputs: Misc_Fairuse_Section6body2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hvis du har spørsmål om disse retningslinjene for rimelig bruk eller mener at innhold eller data på Nettstedet vårt krenker opphavsretten din, vennligst kontakt oss på:`)
};

const pl_misc_fairuse_section6body2 = /** @type {(inputs: Misc_Fairuse_Section6body2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jeśli masz pytania dotyczące tej Polityki dozwolonego użytku lub uważasz, że jakiekolwiek treści lub dane na naszej Stronie naruszają Twoje prawa autorskie, skontaktuj się z nami:`)
};

const pt_br2_misc_fairuse_section6body2 = /** @type {(inputs: Misc_Fairuse_Section6body2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Se você tiver alguma dúvida sobre esta Política de Uso Justo ou se acreditar que qualquer conteúdo ou dado em nosso Site infringe seus direitos autorais, entre em contato conosco:`)
};

const pt_misc_fairuse_section6body2 = /** @type {(inputs: Misc_Fairuse_Section6body2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Se tiver alguma dúvida sobre esta Política de Uso Justo ou acreditar que algum conteúdo ou dado no nosso Site infringe os seus direitos de autor, contacte-nos em:`)
};

const ro_misc_fairuse_section6body2 = /** @type {(inputs: Misc_Fairuse_Section6body2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dacă aveți întrebări despre această Politică de utilizare corectă sau considerați că orice conținut sau date de pe Site-ul nostru vă încalcă drepturile de autor, contactați-ne la:`)
};

const fi_misc_fairuse_section6body2 = /** @type {(inputs: Misc_Fairuse_Section6body2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jos sinulla on kysyttävää tästä kohtuullisen käytön käytännöstä tai uskot jonkin sivustomme sisällön tai tiedon loukkaavan tekijänoikeuksiasi, ota meihin yhteyttä:`)
};

const sv_misc_fairuse_section6body2 = /** @type {(inputs: Misc_Fairuse_Section6body2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Om du har några frågor om denna policy för skälig användning eller om du anser att något innehåll eller data på vår Webbplats kränker din upphovsrätt, kontakta oss på:`)
};

const vi_misc_fairuse_section6body2 = /** @type {(inputs: Misc_Fairuse_Section6body2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nếu bạn có bất kỳ câu hỏi nào về Chính sách Sử dụng Hợp lý này hoặc nếu bạn cho rằng bất kỳ nội dung hoặc dữ liệu nào trên Trang web của chúng tôi vi phạm bản quyền của bạn, vui lòng liên hệ với chúng tôi tại:`)
};

const tr_misc_fairuse_section6body2 = /** @type {(inputs: Misc_Fairuse_Section6body2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bu Adil Kullanım Politikası hakkında herhangi bir sorunuz varsa veya Sitemizdeki herhangi bir içerik veya verinin telif hakkınızı ihlal ettiğini düşünüyorsanız, lütfen bizimle şu adresten iletişime geçin:`)
};

const cs_misc_fairuse_section6body2 = /** @type {(inputs: Misc_Fairuse_Section6body2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Máte-li jakékoli dotazy týkající se těchto Zásad spravedlivého použití nebo se domníváte, že jakýkoli obsah nebo data na naší Stránce porušují vaše autorská práva, kontaktujte nás na:`)
};

const bg_misc_fairuse_section6body2 = /** @type {(inputs: Misc_Fairuse_Section6body2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ако имате въпроси относно тази Политика за честна употреба или смятате, че някакво съдържание или данни на нашия Сайт нарушават вашето авторско право, моля, свържете се с нас на:`)
};

const ru_misc_fairuse_section6body2 = /** @type {(inputs: Misc_Fairuse_Section6body2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Если у вас есть вопросы относительно этой Политики добросовестного использования или вы считаете, что какой-либо контент или данные на нашем Сайте нарушают ваши авторские права, пожалуйста, свяжитесь с нами по адресу:`)
};

const uk_misc_fairuse_section6body2 = /** @type {(inputs: Misc_Fairuse_Section6body2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Якщо у вас є запитання щодо цієї Політики добросовісного використання або ви вважаєте, що будь-який вміст чи дані на нашому Сайті порушують ваші авторські права, зв'яжіться з нами:`)
};

const ar_misc_fairuse_section6body2 = /** @type {(inputs: Misc_Fairuse_Section6body2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`إذا كانت لديك أي أسئلة حول سياسة الاستخدام العادل هذه أو إذا كنت تعتقد أن أي محتوى أو بيانات على موقعنا تنتهك حقوق الطبع والنشر الخاصة بك، يرجى الاتصال بنا على:`)
};

const hi_misc_fairuse_section6body2 = /** @type {(inputs: Misc_Fairuse_Section6body2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`यदि प्रश्न हैं तो संपर्क करें:`)
};

const th_misc_fairuse_section6body2 = /** @type {(inputs: Misc_Fairuse_Section6body2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`หากคุณมีคำถามเกี่ยวกับนโยบายการใช้งานโดยชอบนี้หรือเชื่อว่าเนื้อหาหรือข้อมูลใด ๆ บนไซต์ของเราละเมิดลิขสิทธิ์ของคุณ โปรดติดต่อเราที่:`)
};

const ja_misc_fairuse_section6body2 = /** @type {(inputs: Misc_Fairuse_Section6body2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`このフェアユースポリシーについてご質問がある場合、またはサイト上のコンテンツやデータが著作権を侵害していると思われる場合は、こちらまでご連絡ください：`)
};

const zh_cn2_misc_fairuse_section6body2 = /** @type {(inputs: Misc_Fairuse_Section6body2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`如果您对本合理使用政策有任何疑问，或认为我们网站上的任何内容或数据侵犯了您的版权，请通过以下方式联系我们：`)
};

const zh_hant1_misc_fairuse_section6body2 = /** @type {(inputs: Misc_Fairuse_Section6body2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`如果您對本合理使用政策有任何疑問，或認為我們網站上的任何內容或資料侵犯了您的版權，請透過以下方式聯絡我們：`)
};

const ko_misc_fairuse_section6body2 = /** @type {(inputs: Misc_Fairuse_Section6body2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`본 공정 사용 정책에 대해 문의사항이 있거나 사이트의 콘텐츠나 데이터가 저작권을 침해한다고 생각되면 다음으로 연락해 주세요:`)
};

/**
* | output |
* | --- |
* | "If you have any questions about this Fair Use Policy or if you believe that any content or data on our Site infringes on your copyright, please contact us at:" |
*
* @param {Misc_Fairuse_Section6body2Inputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const misc_fairuse_section6body2 = /** @type {((inputs?: Misc_Fairuse_Section6body2Inputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Misc_Fairuse_Section6body2Inputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_misc_fairuse_section6body2(inputs)
	if (locale === "ms") return ms_misc_fairuse_section6body2(inputs)
	if (locale === "da") return da_misc_fairuse_section6body2(inputs)
	if (locale === "de") return de_misc_fairuse_section6body2(inputs)
	if (locale === "en-US") return en_us2_misc_fairuse_section6body2(inputs)
	if (locale === "es-ES") return es_es2_misc_fairuse_section6body2(inputs)
	if (locale === "es-MX") return es_mx2_misc_fairuse_section6body2(inputs)
	if (locale === "fil") return fil_misc_fairuse_section6body2(inputs)
	if (locale === "fr") return fr_misc_fairuse_section6body2(inputs)
	if (locale === "it") return it_misc_fairuse_section6body2(inputs)
	if (locale === "hu") return hu_misc_fairuse_section6body2(inputs)
	if (locale === "nl") return nl_misc_fairuse_section6body2(inputs)
	if (locale === "no") return no_misc_fairuse_section6body2(inputs)
	if (locale === "pl") return pl_misc_fairuse_section6body2(inputs)
	if (locale === "pt-BR") return pt_br2_misc_fairuse_section6body2(inputs)
	if (locale === "pt") return pt_misc_fairuse_section6body2(inputs)
	if (locale === "ro") return ro_misc_fairuse_section6body2(inputs)
	if (locale === "fi") return fi_misc_fairuse_section6body2(inputs)
	if (locale === "sv") return sv_misc_fairuse_section6body2(inputs)
	if (locale === "vi") return vi_misc_fairuse_section6body2(inputs)
	if (locale === "tr") return tr_misc_fairuse_section6body2(inputs)
	if (locale === "cs") return cs_misc_fairuse_section6body2(inputs)
	if (locale === "bg") return bg_misc_fairuse_section6body2(inputs)
	if (locale === "ru") return ru_misc_fairuse_section6body2(inputs)
	if (locale === "uk") return uk_misc_fairuse_section6body2(inputs)
	if (locale === "ar") return ar_misc_fairuse_section6body2(inputs)
	if (locale === "hi") return hi_misc_fairuse_section6body2(inputs)
	if (locale === "th") return th_misc_fairuse_section6body2(inputs)
	if (locale === "ja") return ja_misc_fairuse_section6body2(inputs)
	if (locale === "zh-CN") return zh_cn2_misc_fairuse_section6body2(inputs)
	if (locale === "zh-Hant") return zh_hant1_misc_fairuse_section6body2(inputs)
	return ko_misc_fairuse_section6body2(inputs)
});
export { misc_fairuse_section6body2 as "misc.fairUse.section6Body" }